/**
 * Agent-level ecommerce trigger settings assembled server-side by
 * {@see MasterKeyWidgetBootstrapService::mergeSharedConfig()} and required
 * client-side by {@see useAbandonedCart}. Unified envelope mapping used to
 * drop these before they reached the mounted widget config.
 */

/** @type {readonly string[]} */
export const ECOMMERCE_TRIGGER_CONFIG_KEYS = [
  'enable_abandoned_cart',
  'abandoned_time',
  'enable_abandoned_cart_polling',
  'enable_upsell',
  'enable_ecommerce',
  'ecommerce_type',
  'free_shipping_message_enabled',
  'show_free_shipping_message',
  'free_shipping_slideout',
  'free_shipping_slideout_text',
  'free_shipping_intent',
  'free_shipping_intent_id',
  'free_shipping_threshold',
  'free_low_threshold',
  'show_shipping_progress',
  'show_shipping_progress_on_cart',
  'free_shipping_progress_slideout',
  'free_shipping_progress_slideout_text',
  'free_shipping_progress_intent',
  'free_shipping_progress_intent_id',
  'currency_symbol',
  'currency_position',
  'thousands_separator',
  'decimal_separator',
]

/**
 * @param {...(Record<string, unknown>|null|undefined)} sources
 * @returns {Record<string, unknown>}
 */
export function pickEcommerceTriggerConfig(...sources) {
  /** @type {Record<string, unknown>} */
  const out = {}
  for (const key of ECOMMERCE_TRIGGER_CONFIG_KEYS) {
    for (const source of sources) {
      if (source == null || typeof source !== 'object') continue
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        out[key] = source[key]
        break
      }
    }
  }
  return out
}
